var _circle, _rect, _rect2, _rect3, _rect4, _rect5, _path, _circle2, _path2, _rect6, _rect7, _rect8, _rect9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAbTestB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 142,
    height: 142,
    viewBox: "0 0 142 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 71,
    r: 71,
    fill: "#EDF1FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 40,
    width: 75,
    height: 62,
    rx: 2,
    stroke: "#4C6FFF",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 55,
    width: 50,
    height: 17,
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 46,
    y: 77,
    width: 14,
    height: 17,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 77,
    width: 14,
    height: 17,
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 77,
    width: 14,
    height: 17,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34 42C34 40.8954 34.8954 40 36 40H107C108.105 40 109 40.8954 109 42V48H34V42Z",
    fill: "#FF9349",
    stroke: "#4C6FFF",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 75.2346,
    r: 14,
    fill: "#EDF1FF",
    stroke: "#4C6FFF",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M71.5764 76.0626H68.8372L68.8225 74.4659H71.0857C71.4861 74.4659 71.8108 74.4171 72.0598 74.3194C72.3137 74.2217 72.4993 74.0801 72.6165 73.8946C72.7336 73.7042 72.7922 73.4698 72.7922 73.1915C72.7922 72.8741 72.7336 72.6177 72.6165 72.4224C72.4993 72.2271 72.3137 72.0855 72.0598 71.9976C71.8108 71.9048 71.4885 71.8585 71.093 71.8585H69.7014V80.6695H67.3137V70.0054H71.093C71.7327 70.0054 72.304 70.064 72.8069 70.1812C73.3098 70.2984 73.7371 70.4791 74.0886 70.7232C74.4451 70.9673 74.7161 71.2725 74.9016 71.6387C75.0872 72.0049 75.1799 72.4371 75.1799 72.9351C75.1799 73.3697 75.0823 73.775 74.887 74.1509C74.6965 74.5269 74.3889 74.8321 73.9641 75.0665C73.5393 75.3008 72.9705 75.4278 72.2576 75.4473L71.5764 76.0626ZM71.4812 80.6695H68.2292L69.0935 78.8238H71.4812C71.8474 78.8238 72.1453 78.7652 72.3748 78.648C72.6042 78.5308 72.7727 78.3721 72.8801 78.1719C72.9875 77.9717 73.0413 77.7471 73.0413 77.4981C73.0413 77.2051 72.99 76.9512 72.8875 76.7364C72.7898 76.5215 72.6335 76.3555 72.4187 76.2383C72.2087 76.1212 71.928 76.0626 71.5764 76.0626H69.4377L69.4524 74.4659H72.0671L72.6238 75.0958C73.3025 75.0811 73.8445 75.191 74.2498 75.4254C74.6599 75.6548 74.9553 75.9576 75.136 76.3336C75.3167 76.7095 75.407 77.1075 75.407 77.5274C75.407 78.2208 75.2581 78.8018 74.9602 79.2706C74.6624 79.7344 74.2205 80.0836 73.6345 80.3179C73.0535 80.5523 72.3357 80.6695 71.4812 80.6695Z",
    fill: "#4C6FFF"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 39,
    y: 43,
    width: 2,
    height: 2,
    fill: "#4C6FFF"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 43,
    width: 2,
    height: 2,
    fill: "#4C6FFF"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 43,
    width: 2,
    height: 2,
    fill: "#4C6FFF"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 43,
    width: 26,
    height: 2,
    fill: "#4C6FFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbTestB);
export default __webpack_public_path__ + "static/media/ab_test_b.588403939668a320364a8a687b0685a7.svg";
export { ForwardRef as ReactComponent };